var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAppleMonochrome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.738 16.382c-.014-2.54 1.133-4.457 3.454-5.87-1.299-1.86-3.26-2.885-5.85-3.086-2.453-.194-5.133 1.433-6.114 1.433-1.036 0-3.412-1.364-5.277-1.364C4.096 7.558 0 10.575 0 16.714c0 1.813.332 3.689.995 5.62.884 2.54 4.075 8.768 7.405 8.665 1.74-.042 2.97-1.24 5.236-1.24 2.196 0 3.336 1.24 5.277 1.24 3.357-.049 6.244-5.71 7.087-8.257-4.504-2.125-4.262-6.229-4.262-6.36Zm-3.91-11.364C19.714 2.775 19.541.734 19.486 0c-1.665.097-3.592 1.135-4.69 2.415-1.209 1.37-1.92 3.066-1.768 4.977 1.803.138 3.446-.79 4.8-2.374Z",
    fill: "#F3F2F1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAppleMonochrome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/apple-monochrome.692f8172e16ef0f9e2217b16b72e047d.svg";